import React, { Fragment, useEffect, useState } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Link, Typography } from '@material-ui/core';
import settings from '../../../utils/settings';
import {
  onlyForUS,
  inactiveStatesInUS,
  onlyForAU,
  onlyForNZ,
  onlyForNC,
  onlyForDE,
  onlyForNL,
  onlyForBE,
  onlyForMX,
  onlyForBR,
  onlyForIN,
  onlyForFr,
  viewOnlyDisabledLabels,
  selfInstallerLabels
} from 'enlm_ui_common';
import analytics from '../../../utils/analytics';
import { getToken, getCountryBasedLink, constructUrlWithParams } from '../../../utils/helper';
import { flatten, get, isEmpty } from '../../../utils/lodash';
import I18n from '../../../config/locales';
import { setSolargrafPopupDetails } from '../../../containers/Layouts/actions';
import feature from '../../../utils/feature';
import { getPlatformBasedUrl } from '../../../config/platformBasedUrls/url';
import SolargrafPopupFlow from '../../Solargraf/SolargrafPopupFlow';

const useStyles = makeStyles(theme => ({
  list: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.25, 0)
  },
  listLink: {
    color: `${theme.palette.tertiary.main} !important`,
    cursor: 'pointer !important',
    marginLeft: `${theme.spacing(1.25)}px !important`,
    display: 'flex !important',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  bullets: {
    width: theme.spacing(1.25),
    height: theme.spacing(1.25),
    borderRadius: theme.spacing(1.25),
    backgroundColor: theme.palette.secondary.dark
  },
  comingSoon: {
    color: '#AAA9A9 !important',
    pointerEvents: 'none'
  },
  comingSoonLabel: {
    background: '#A5A5A5 0% 0% no-repeat padding-box',
    letterSpacing: '0 !important',
    lineHeight: '0 !important',
    color: theme.palette.secondary.main,
    textTransform: 'uppercase',
    height: theme.spacing(1.5),
    fontSize: '9px !important',
    display: 'flex',
    fontWeight: 'bold',
    alignItems: 'center',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(0, 0.5),
    whiteSpace: 'nowrap'
  },
  submenuLink: {
    borderBottom: '1px solid #70707036',
    '&:last-child': {
      border: 'none'
    }
  },
  newLabel: {
    background: '#FF7141 0% 0% no-repeat padding-box',
    letterSpacing: '0 !important',
    lineHeight: '0 !important',
    color: theme.palette.secondary.main,
    textTransform: 'uppercase',
    height: theme.spacing(1.5),
    fontSize: '9px !important',
    display: 'flex',
    fontWeight: 'bold',
    alignItems: 'center',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(0, 0.5),
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing(1.5)
  }
}));

const AccountList = props => {
  const gaAnalytics = new analytics();
  const {
    accountList,
    companyId,
    leadOptIn,
    title,
    state,
    abLreEnabled,
    abPermitEnabled,
    abBOMEnabled,
    abSgipEnabled,
    enlightenManagerToken,
    asSubMenu = false,
    einOptIn = false,
    hasTier = false,
    abEinMerchandise,
    belongsToAus,
    belongsToDe,
    belongsToNl,
    belongsToBe,
    belongsToIn,
    belongsToMx,
    belongsToBr,
    belongsToUs,
    belongsToIt,
    companyInfo,
    dashboardLinks,
    countryCode,
    einOptOut,
    belongsToNz,
    belongsToNc,
    belongsToFr,
    pathName,
    searchParam = '',
    accountData,
    isHardLoad = false,
    featureList,
    viewOnlyAccess,
    handleCloseTooltip = () => {},
    setSolargrafPopupDetails,
    fromITK
    // showBomDialog = () => {}
  } = props;

  const classes = useStyles();
  const isAcmAdmin = get(accountData, 'is_acm_admin', false);
  const isEinOptOut = get(companyInfo, 'ein_opt_out', false) || einOptOut;
  const isSelfInstaller = get(accountData, 'self_installer', false);
  const isSolargrafEnabled = !isEmpty(featureList) ? feature.isFeatureEnabled('SOLARGRAF_ENABLED') : false;
  const isRMADashboardEnabled = !isEmpty(featureList) ? feature.isFeatureEnabled('RMA_DASHBOARD') : false;
  const isDRSEnabled = !isEmpty(featureList)
    ? isSelfInstaller ? feature.isFeatureEnabled('DRS_ENABLED_USER') : feature.isFeatureEnabled('DRS_ENABLED_COMPANY')
    : false;
  const { navigateToManager = false, name, isExternalLink = false, label, isComingSoon = false } = accountList;
  const isDRSLabel = label === 'design-review';
  let isDisabledLabel = false;
  let url = accountList.url;
  const dataPlanExtensionEnabled = !isEmpty(featureList) ? feature.isFeatureEnabled("CELLMODEM_DATA_PLAN_EXTENSION") : false;
  while (url && url.includes(':company_id')) {
    url = url.replace(':company_id', companyId);
  }

  const show_link = get(dashboardLinks, 'ein.show_link', false);

  const [ navigationLink, setNavigationLink ] = useState(url);
  useEffect(
    () => {
      const getNavigationLink = (label, url) => {
        const token = getToken() || enlightenManagerToken;
        switch (label) {
          case 'enphase_store':
            return getCountryBasedLink('enphaseStore');
          case 'product-warranty-extension':
            return `${getCountryBasedLink('productWarrantyExtension')}&token=${token}`;
          default:
            return url;
        }
      };
      const breadcrumbPath = pathName && pathName.includes('account') ? 'account' : 'dashboard';
      const urlPath = `/manager/${breadcrumbPath}/${url}`;
      const notNavigateToManager = isExternalLink ? getNavigationLink(label, url) : urlPath;
      const link = navigateToManager ? settings.enlightenMenuUrl(url) : notNavigateToManager;
      setNavigationLink(constructUrlWithParams(link, searchParam));
    },
    [ countryCode, enlightenManagerToken, isExternalLink, label, navigateToManager, pathName, url, searchParam ]
  );
  if (label === 'ac-module-admin' && !isAcmAdmin) {
    return null;
  }

  if (label === 'lead-program' && !leadOptIn) {
    return null;
  }

  if (label === 'enphase_store' && (belongsToIn || belongsToMx || belongsToBr || belongsToIt)) {
    return null;
  }

  if (label === 'ein-merchandise' && !(abEinMerchandise && einOptIn && hasTier && belongsToUs && !fromITK)) {
    return null;
  }

  if (label === 'design-tool' && !isSolargrafEnabled) {
    return null;
  }
  if(label === 'rma-dashboard' && !isRMADashboardEnabled){
    return null;
  }
  if( label === 'data-plan-extension' && !dataPlanExtensionEnabled){
    return null;
  }
  if (label === 'area-coverage' && !show_link) {
    return null;
  }
  if (label === 'ein-program' && !show_link) {
    return null;
  }

  const allCountryWiseLabel = new Set(
    flatten([
      onlyForUS,
      onlyForAU,
      onlyForNZ,
      onlyForNC,
      onlyForDE,
      onlyForNL,
      onlyForBE,
      onlyForMX,
      onlyForBR,
      onlyForIN,
      onlyForFr
    ])
  );
  const labelInUs = onlyForUS.includes(label) && belongsToUs;
  const labelInAus = onlyForAU.includes(label) && belongsToAus;
  const labelInNz = onlyForNZ.includes(label) && belongsToNz;
  const labelInNc = onlyForNC.includes(label) && belongsToNc;
  const labelInDe = onlyForDE.includes(label) && belongsToDe;
  const labelInNl = onlyForNL.includes(label) && belongsToNl;
  const labelInBe = onlyForBE.includes(label) && belongsToBe;
  const labelInMx = onlyForMX.includes(label) && belongsToMx;
  const labelInBr = onlyForBR.includes(label) && belongsToBr;
  const labelInIn = onlyForIN.includes(label) && belongsToIn;
  const labelInFr = onlyForFr.includes(label) && belongsToFr;

  if (
    [ ...allCountryWiseLabel ].includes(label) &&
    !(
      labelInUs ||
      labelInAus ||
      labelInNz ||
      labelInNc ||
      labelInDe ||
      labelInNl ||
      labelInBe ||
      labelInMx ||
      labelInBr ||
      labelInIn ||
      labelInFr
    )
  ) {
    return null;
  }

  if (isSelfInstaller && !selfInstallerLabels.includes(label)) {
    return null;
  }

  if (label === 'labor-protection' && ((belongsToUs && inactiveStatesInUS.includes(state)) || !abLreEnabled)) {
    isDisabledLabel = true;
  }
  if (label === 'sgip-incentive' && (!belongsToUs || !abSgipEnabled)) {
    isDisabledLabel = true;
  }
  if (label === 'permitting-assistance' && (!belongsToUs || !abPermitEnabled)) {
    isDisabledLabel = true;
  }
  if (label === 'bom-calculator' && (!belongsToUs || !abBOMEnabled)) {
    isDisabledLabel = true;
  }
  if (label === 'ein-program' && isEinOptOut) {
    isDisabledLabel = true;
  }
  if (isDRSLabel && (!belongsToUs || !isDRSEnabled)) {
    isDisabledLabel = true;
  }
  // though drs is external link we need to open it in same tab
  const target = isExternalLink && label !== 'design-review' ? '_blank' : '_self';
  const hasComingSoonLabel = isComingSoon || isDisabledLabel;
  const disabledLinks = viewOnlyAccess && viewOnlyDisabledLabels.includes(label);
  const linkClass = clsx(classes.listLink, (hasComingSoonLabel || disabledLinks) && classes.comingSoon);

  const comingSoonLabel = (
    <Fragment>
      {I18n.t(`accountInfo.${name}`)}
      <Typography className={classes.comingSoonLabel}>{I18n.t('header.comingSoon')}</Typography>
    </Fragment>
  );

  const link = I18n.t(`accountInfo.${name}`);

  const listName = hasComingSoonLabel ? comingSoonLabel : link;

  const events = {
    event: 'triggerMenuList'
  };
  const trackEvent = listName => {
    const dataLayer = {
      menuName: title,
      menuValue: listName
    };
    gaAnalytics.triggerEvent(events, dataLayer);
  };
  const hardLoad =
    isHardLoad || label === 'labor-protection' || label === 'lead-program' || label === 'permitting-assistance';

  const designTool = () => {
    asSubMenu && handleCloseTooltip();
    trackEvent(asSubMenu ? listName + ' dropdown' : listName);
    setSolargrafPopupDetails({
      startSolargrafPopupFlow: true,
      solargrafAccessAction: '',
      linkWithSolargrafSuccess: ''
    });
  };

  const handleNavigation = cbkFunction => {
    cbkFunction();
    asSubMenu && handleCloseTooltip();
  };

  const handleDrs = () => {
    const token = getToken() || enlightenManagerToken;
    const link = navigationLink;
    trackEvent(asSubMenu ? listName + ' dropdown' : listName);
    window.location.replace(link);
  };

  const renderAccountList = () => {
    let accountListName = '';
    switch (true) {
      case hasComingSoonLabel:
        accountListName = (
          <Typography component="div" className={linkClass}>
            {listName}
          </Typography>
        );
        break;
      case label === 'design-tool':
        accountListName = (
          <Typography className={linkClass} component="div" onClick={() => designTool()}>
            {listName}
          </Typography>
        );
        break;
      case label === 'design-review':
        accountListName = (
          <Typography className={linkClass} component="div" onClick={handleDrs}>
            {listName}
          </Typography>
        );
        break;
      case label === 'bom-calculator':
        accountListName = (
          <Typography
            className={linkClass}
            component="div"
            onClick={() => {
              gaAnalytics.triggerEvent(
                { event: 'triggerBomEnlighten' },
                { menuValue: asSubMenu ? 'entrypoint_services_menu' : 'entrypoint_services' }
              );
              window.open(
                getPlatformBasedUrl('dashboard.systemsTable.leadExistingBomUrl', {
                  companyId
                }),
                '_self'
              );
            }}
          >
            {listName}
          </Typography>
        );
        break;
      case isExternalLink:
      case navigateToManager:
      case hardLoad:
        accountListName = (
          <Link
            href={navigationLink}
            className={linkClass}
            target={target}
            onClick={() => handleNavigation(() => trackEvent(asSubMenu ? `${listName} dropdown` : listName))}
          >
            {listName}
          </Link>
        );
        break;
      default:
        accountListName = (
          <Link
            to={navigationLink}
            className={linkClass}
            component={RouterLink}
            onClick={() => handleNavigation(() => trackEvent(asSubMenu ? `${listName} dropdown` : listName))}
          >
            {listName}
          </Link>
        );
        break;
    }
    return (
      <Fragment>
        {accountListName}
        {(label === 'sgip-incentive' || label === 'permitting-assistance') &&
        !hasComingSoonLabel && <Typography className={classes.newLabel}>{I18n.t('dashboard.new')}</Typography>}
      </Fragment>
    );
  };

  if (asSubMenu) {
    let subMenuLinkClass = clsx(classes.list, classes.submenuLink);
    return (
      <Typography component="div" className={subMenuLinkClass}>
        {renderAccountList()}
      </Typography>
    );
  }

  return (
    <Typography component="div" className={classes.list}>
      <Typography component="div" className={classes.bullets} />
      {renderAccountList()}
      {fromITK && <SolargrafPopupFlow />}
    </Typography>
  );
};

const mapStateToProps = state => ({
  belongsToAus: state.appReducer.belongsToAus,
  belongsToDe: state.appReducer.belongsToDe,
  belongsToNl: state.appReducer.belongsToNl,
  belongsToBe: state.appReducer.belongsToBe,
  belongsToIn: state.appReducer.belongsToIn,
  belongsToMx: state.appReducer.belongsToMx,
  belongsToBr: state.appReducer.belongsToBr,
  belongsToUs: state.appReducer.belongsToUs,
  belongsToNz: state.appReducer.belongsToNz,
  belongsToNc: state.appReducer.belongsToNc,
  belongsToFr: state.appReducer.belongsToFr,
  belongsToIt: state.appReducer.belongsToIt,
  companyInfo: state.appReducer.companyInfo,
  countryCode: state.appReducer.countryCode,
  einOptOut: state.appReducer.einOptOut,
  accountData: state.accountReducer.accountDetail,
  featureList: state.appReducer.featureList,
  viewOnlyAccess: state.accountReducer.viewOnlyAccess,
  fromITK: state.appReducer.fromITK
});

const mapDispatchToProps = dispatch => ({
  setSolargrafPopupDetails: payload => dispatch(setSolargrafPopupDetails(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountList);
